​<picture (click)="openFile(source)">
  <source srcset={{source}}>
  <img src={{source}} class="img-thumbnail">
</picture>
